import { Typography } from "@mui/material";
import { SmsModalDescriptionWarning } from "./warning";

export interface ISmsModalDescriptionProps {
  candidatesCount: number;
  eligibleCandidatesCount: number;
}

export const SmsModalDescription = ({ candidatesCount, eligibleCandidatesCount }: ISmsModalDescriptionProps) => {
  if (candidatesCount === eligibleCandidatesCount) {
    return (
      <Typography variant="body1">
        Vous avez sélectionné{" "}
        {candidatesCount > 1 ? `${candidatesCount} candidats afin de leur` : "un candidat afin de lui"} envoyer un SMS.
        Vous pouvez sélectionner un modèle type ci dessous ou envoyer un SMS libre.
      </Typography>
    );
  }
  return (
    <>
      <SmsModalDescriptionWarning candidatesCount={candidatesCount} eligibleCandidatesCount={eligibleCandidatesCount} />
      <Typography variant="body1">
        Vous pouvez sélectionner un modèle type ci dessous ou envoyer un SMS libre.
      </Typography>
    </>
  );
};
